/**
 * @description
 */

import './pcThemeDialog.scss';

import React, { useState } from 'react';
import { components } from 'common';
import { removeElementsByClass } from '../../@utils';
import { Button, ButtonType } from '@umu/umu-design'
interface IProps {
    title: string;
    body: JSX.Element;
    cancelTitle?: string;
    confirmTitle?: string;
    canClose?: boolean;
    dialogWidth?: string;
    className?: string;
    saveBtnType?:ButtonType;
    onDialogClose?(): void;
    onClose?(): void;
    onConfirm?(): void;
}
const { PortalDialog } = components;

export default function PCThemeDialog({
    title,
    body,
    cancelTitle,
    confirmTitle,
    dialogWidth = '500px',
    canClose = false,
    onDialogClose,
    className = 'pc-theme-dialog',
    saveBtnType = 'primary-blue',
    onClose,
    onConfirm,
}: IProps) {
    const [isShow, setIsShow] = useState(true);
    const close = () => {
        setIsShow(false);
        onDialogClose && onDialogClose()
        removeElementsByClass('.dialog-mask');
    };
    const renderDialog = () => {
        return (
            <div className="pc-theme-dialog-main">
                <div className="pc-theme-dialog-header">
                    <div className="dialog-title">{title}</div>
                </div>
                <div className="pc-theme-dialog-body">{body}</div>
                <div className="pc-theme-dialog-footer">
                    {cancelTitle && onClose ? (
                        <div className="action cancel-action">
                            <Button onClick={onClose} type="ghost-grey">
                                {cancelTitle}
                            </Button>
                        </div>
                    ) : null}
                    {confirmTitle && onConfirm ? (
                        <div className="action submit-action">
                            <Button
                                onClick={() => {
                                    close();
                                    onConfirm();
                                }}
                                type={(saveBtnType)}
                            >
                                {confirmTitle}
                            </Button>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

    const render = () => {
        return (
            <PortalDialog
                show={isShow}
                hasMask={true}
                className={className}
                canClose={canClose}
                close={close}
                width={dialogWidth}
            >
                {renderDialog()}
            </PortalDialog>
        );
    };
    return render();
}
